$(function () {
  while (window.BS && window.BS.loader && window.BS.loader.length) {
    window.BS.loader.pop()();
  }
});
